<ng-container *ngIf="!actionItems; else labelWithActionItems">
    <!-- Separate to different component without form-group div etx -->
    <div *ngIf="label" class="sh-form-group__label" [ngClass]="{ '-sh-is-required': required }">
        <label [for]="for"><sh-field-label [label]="label" [labelIcons]="labelIcons()"></sh-field-label></label>
    </div>
    <em *ngIf="helpText" class="sh-form-group__label__em">{{ helpText }}</em>
</ng-container>

<ng-template #labelWithActionItems>
    <div class="sh-action-group" style="margin-bottom: 0px">
        <div class="sh-action-group__item">
            <div *ngIf="label" class="sh-form-group__label" [ngClass]="{ '-sh-is-required': required }" style="margin-bottom: 0px">
                <label [for]="for"><sh-field-label [label]="label" [labelIcons]="labelIcons()"></sh-field-label></label>
            </div>
        </div>
        <div class="sh-action-group__item">
            <sh-action-item *ngFor="let actionItem of actionItems" [item]="actionItem" style="margin-bottom: 0.625rem"></sh-action-item>
        </div>
    </div>
    <em *ngIf="helpText" class="sh-form-group__label__em">{{ helpText }}</em>
</ng-template>
